<template>
	<div class="menu">
		<router-link
			class="menu__item preface"
			tag="div" to="/"
		>
			Preface
		</router-link>
		<router-link
			v-if ="!mobileMenu"
			class="menu__item table-of-content"
			:class="{ active: routeName === 'tableOfContents' }"
			tag="div" to="/table-of-contents"
		>
			Table of Contents
		</router-link>

		<div>
			<router-link
				v-for="(chapter, index) in chapters"
				:key="index"
				class="menu__item chapters"
				tag="div" 
				:to="`/chapter/${index + 1}`"
			>
				<small>Chapter {{ index + 1 }}. </small> 
				<strong>{{ getChapterTitles(chapter).title }}</strong>

				<div 
					v-if="getChapterTitles(chapter).subtitles.length"
					class="menu__item--subTitles"
				>
					<div 
						v-for="(subtitle, subIndex) in getChapterTitles(chapter).subtitles"
						:key="subtitle"
					>
						<small>{{ `${index + 1}.${subIndex + 1}` }}</small> {{ subtitle }}
					</div>
				</div>
			</router-link>
		</div>
	</div>
</template>

<script>
	import meta from '@data/meta.json';
	import { chapterTitles } from '@/helpers/content.js';

	export default {
		props: {
			mobileMenu: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			routeName() {
				return this.$route.name;
			},
			chapters() {
				return meta.chapters;
			}
		},
		methods: {
			getChapterTitles(source) {
				return chapterTitles(source);
			}
		}
	};
</script>


<style lang="scss" scoped>
	.menu {
		&__item {
			font-weight: 300;
			cursor: pointer;
			margin: 1em 0;
			padding: 0.25em 0.5em;
			border-radius: 3px;

			&.chapters {
				margin: 0.5em 0;
			}

			&:hover {
				background: rgba($primary, 0.1);
			}

			&.active {
				background: rgba($primary, 0.2);
			}

			&--subTitles {
				div {
					font-size: 0.95em;
					margin: 0.25em 1em;
				}
			}
		}

		@include desktop { 
			.menu {
				&__item {
					padding: 0.25em 1em;

					small {
						margin-right: 10px;
					}

					&--subTitles {
						div {
							margin: 0.25em 2em;
						}
					}
				}
			}
		}
	}
</style>


